import { useRef } from 'react';
import { UseVideoEditTagSectionReturn } from './types';

/**
 * VideoEditTagSectionコンポーネントのロジックを管理するカスタムフック
 * 
 * @param tags 現在設定されているタグの配列
 * @param setTags タグの配列を更新する関数
 * @param inputValue タグ入力フィールドの現在の値
 * @param setInputValue タグ入力フィールドの値を更新する関数
 * @param isComposing IME入力中かどうかのフラグ
 * @param setIsComposing IME入力状態を更新する関数
 * @returns VideoEditTagSectionの操作に必要な関数と参照
 */
const useVideoEditTagSection = (
  tags: string[],
  setTags: React.Dispatch<React.SetStateAction<string[]>>,
  inputValue: string,
  setInputValue: React.Dispatch<React.SetStateAction<string>>,
  isComposing: boolean,
  setIsComposing: React.Dispatch<React.SetStateAction<boolean>>
): UseVideoEditTagSectionReturn => {
  // inputRefを作成
  const inputRef = useRef<HTMLInputElement>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = () => {
    setIsComposing(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // 入力中（IME変換中）は何もしない
    if (isComposing) return;

    // カンマやスペース、Enterキーでタグを追加
    if ([',', ' ', 'Enter'].includes(e.key)) {
      e.preventDefault();
      addTag();
    }
  };

  const addTag = () => {
    const trimmedValue = inputValue.trim();
    if (trimmedValue && !tags.includes(trimmedValue)) {
      setTags([...tags, trimmedValue]);
      setInputValue('');
    }
  };

  const removeTag = (index: number) => {
    setTags(tags.filter((_, i) => i !== index));
  };

  return {
    inputRef,
    handleInputChange,
    handleCompositionStart,
    handleCompositionEnd,
    handleKeyDown,
    addTag,
    removeTag
  };
};

export default useVideoEditTagSection; 